export const API_URL = window.apiurl;
// export const API_URL = "https://microsite-netzwerk.de/dbmm-test/dbmm-api/";
// export const API_URL = "https://microsite-netzwerk.de/dbmm-test-1/dbmm-api/";

